import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const PlayerCtrlsBackButton = ({ video_id, onClick }) => {
  return (
    <a
      id="player_rewind"
      title={video_id ? "Play Music Video" : "No Video for this song"}
      href="/my_song_history"
      onClick={onClick}
    >
      <FontAwesomeIcon
        icon="redo"
        className={`icon-action  ${video_id ? "video" : "novideo"}`}
        style={{ margin: "0rem 1rem", fontSize: "1.1rem" }}
      />
    </a>
  );
};

export default PlayerCtrlsBackButton;
